import { Box } from "@mui/material"
import { StandardModelPrint } from "./StandardModelPrint"
import { DPAModelPrint } from "./DPAModelPrint"
interface PrintOthersProps {
  exportModel: string
  currPrint: any
  updateModel: (data: any) => void
}

export const PrintOthers = ({
  exportModel,
  currPrint,
  updateModel,
}: PrintOthersProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {exportModel === "StandardModel" && (
          <StandardModelPrint
            currPrint={currPrint}
            updateModel={updateModel}
          />
        )}
        {exportModel === "DPAModel" && (
          <DPAModelPrint
            currPrint={currPrint}
            updateModel={updateModel}
          />
        )}
      </Box>
    </Box>
  )
}
